module.exports = __webpack_public_path__ + "img/NED.707b6c11.png";